import { ApiProperty } from '@nestjs/swagger';
import { Expose, Transform } from 'class-transformer';
import { ISODuration } from '@youhelp-ru/core';
import type { ApiServerEntityIDType } from '../../../types';
import { PromocodeType } from './type';

export class PromocodeViewModel {
  @Expose()
  @ApiProperty()
  id: string;

  @Expose()
  @ApiProperty()
  type: PromocodeType;

  /**
   * Period in ISO8601
   * @example P3Y6M4DT12H30M5S
   */
  @Expose()
  @ApiProperty()
  @Transform(
    ({ value }) => {
      if (value == null || value === '') {
        return undefined;
      }
      if (value instanceof ISODuration) {
        return value;
      }
      if (typeof value === 'object') {
        return new ISODuration(value);
      }
      return ISODuration.parse(String(value));
    },
    { toClassOnly: true },
  )
  // Nest ClassSerializerInterceptor otherwise emits nested ISODuration as `{}`
  // (no @Expose on value-object fields) — badge / free-period UI then disappears.
  @Transform(
    ({ value }) => {
      if (value == null || value === '') {
        return undefined;
      }
      if (value instanceof ISODuration) {
        const s = value.toString();
        return s === '' ? undefined : s;
      }
      if (typeof value === 'string') {
        return value;
      }
      const s = new ISODuration(value).toString();
      return s === '' ? undefined : s;
    },
    { toPlainOnly: true },
  )
  freePeriod?: ISODuration;

  @Expose()
  @ApiProperty()
  createdAt: string;

  @Expose()
  @ApiProperty()
  ownedByClientId?: ApiServerEntityIDType;
}
